import { render, staticRenderFns } from "./DepartmentManageView.vue?vue&type=template&id=448e7654&scoped=true"
import script from "./DepartmentManageView.vue?vue&type=script&lang=js"
export * from "./DepartmentManageView.vue?vue&type=script&lang=js"
import style0 from "./DepartmentManageView.vue?vue&type=style&index=0&id=448e7654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448e7654",
  null
  
)

export default component.exports